import { CSS_PROPERTY, getCssBasedOnRtl, media } from '../../styles';
import styled, { DefaultTheme } from 'styled-components';

export const Anchor = styled.a`
  color: ${({ theme }) => theme.ui.text.color};
  font-weight: normal;
  text-decoration: none;
  word-break: break-word;
  &:hover {
    text-decoration: underline;
  }
  &:focus-visible {
    outline-style: auto;
    outline-width: 5px;
  }
`;

const baseStyle = (theme: DefaultTheme): string => {
  return `
    align-items: flex-end;
    color: ${theme.ui.text.color};
    display: flex;
    flex: 1 1 auto;
    font-size: ${theme.typography.size.xsmall};
    font-weight: ${theme.typography.weight.regular};
`;
};

export const SideContainer = styled.div`
  ${({ theme }) => baseStyle(theme)}
  ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.TEXT_ALIGNMENT_LEFT)};
  justify-content: left;
  padding: ${({ theme }) => theme.spacing.base.sm} 0;
  ${({ theme }) => getCssBasedOnRtl(theme, CSS_PROPERTY.PADDING_RIGHT, theme.spacing.base.sm)};

  ${media.mobilePortrait} {
    justify-content: center;
    padding: 0 0;
  }
`;

export const CenterContainer = styled.div`
  ${({ theme }) => baseStyle(theme)}
  justify-content: center;
  padding: 0;
`;
